// copied from @mui/system/createStyled
function slotShouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
export default slotShouldForwardProp;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/styles/slotShouldForwardProp.js
// module id = 454
// module chunks = 25